module.exports = __webpack_public_path__ + "media/images/logo-confirma-d659f328d7ca99bfd07e30dafd10b02b.png";